// src/components/admin/AdminVersements.jsx — versements aux organisateurs (RIB)

import React from "react";
import { getVersements } from "../../services/AdminGestionService";
import { useListeAdmin, TableAdmin, Pagination, Recherche, Filtre, EnTete, Badge, BoutonActualiser, euros, dateFr } from "./AdminUI";

const STATUTS = {
    en_attente: ["orange", "En attente"],
    verse: ["vert", "Versé"],
    echec: ["rouge", "Échec"],
    annule: ["gris", "Annulé"],
};

const AdminVersements = () => {
    const L = useListeAdmin(getVersements, { q: "", statut: "" });
    const delai = L.reponse?.delai_jours ?? 15;

    const colonnes = [
        { cle: "reference", titre: "Billet", rendu: (v) => <span className="font-mono text-xs">{v.reference || `#${v.id}`}</span> },
        { cle: "createur", titre: "Organisateur", rendu: (v) => (
            <div>
                <div className="font-semibold text-gray-900">{v.createur || "—"}</div>
                <div className="text-[11px] text-gray-500">{v.createur_email}</div>
            </div>
        )},
        { cle: "nomEven", titre: "Événement", rendu: (v) => (
            <div className="max-w-[200px]">
                <div className="line-clamp-1">{v.nomEven}</div>
                <div className="text-[11px] text-gray-500">le {dateFr(v.dateEven)}</div>
            </div>
        )},
        { cle: "montant_organisateur", titre: "Montant", classe: "text-right", rendu: (v) => <b>{euros(v.montant_organisateur)}</b> },
        { cle: "statut_versement", titre: "Statut", rendu: (v) => {
            const s = STATUTS[v.statut_versement] || ["gris", v.statut_versement || "—"];
            return <Badge couleur={s[0]}>{s[1]}</Badge>;
        }},
        { cle: "date", titre: "Versé le / prévu", rendu: (v) =>
            v.verse_le
                ? <span className="text-xs text-green-700">{dateFr(v.verse_le, true)}</span>
                : v.statut_versement === "annule" ? "—"
                : <span className="text-xs text-gray-500">à partir du {dateFr(v.versement_prevu)}</span> },
        { cle: "stripe", titre: "Réf. Stripe", rendu: (v) => v.stripe_transfer_id
            ? <span className="font-mono text-[11px] text-gray-500">{v.stripe_transfer_id}</span>
            : <span className="text-gray-300">—</span> },
        { cle: "erreur", titre: "Erreur", rendu: (v) => v.erreur_versement
            ? <span className="text-[11px] text-red-600 line-clamp-2 max-w-[220px]" title={v.erreur_versement}>{v.erreur_versement}</span>
            : null },
    ];

    return (
        <div className="max-w-7xl mx-auto">
            <EnTete titre="Versements Stripe"
                sousTitre={`Virement vers le RIB de l'organisateur ${delai} jours après l'événement (commande billetterie:verser, chaque jour à 6 h)`}
                actions={<>
                    <Recherche valeur={L.filtres.q} onChange={(v) => L.setFiltre("q", v)} placeholder="Réf., organisateur, événement…" />
                    <Filtre valeur={L.filtres.statut} onChange={(v) => L.setFiltre("statut", v)}
                        options={[["", "Tous"], ["en_attente", "En attente"], ["verse", "Versés"], ["echec", "Échecs"], ["annule", "Annulés"]]} />
                    <BoutonActualiser onClick={L.recharger} />
                </>}
            />
            <TableAdmin colonnes={colonnes} lignes={L.page?.data} loading={L.loading} erreur={L.erreur}
                ligneClasse={(v) => (v.statut_versement === "echec" ? "bg-red-50/40" : "")} />
            <Pagination page={L.page} onPage={L.allerA} onParPage={L.setParPage} />
        </div>
    );
};

export default AdminVersements;